import {StyledGlobalMainContainer} from '../globalStyle'
import styled from 'styled-components'

export const StyledText = styled.div`
  margin-top: 5px;
  font-family: "Gilroy",sans-serif;
  font-size: 14px;
  line-height: 21px;
  color: #797A80;
  font-weight: 400;
  @media(max-width: 768px){
    text-align: justify;
  }
`

export const StyledContainer = styled(StyledGlobalMainContainer)`
  margin-top: 60px;
  padding-top: 60px;
  padding-bottom: 60px;
  @media (max-width: 768px) {
    padding-bottom: 42px;
  }
  @media (max-width: 768px) {
    margin-top: 42px;
  }
`


export const StyledInnerContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.4fr 1fr;
  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    grid-row-gap: 40px;
    & > div {
      max-width: 50%;
      justify-self: center;
    }
  }

`

export const StyledTitleContainer = styled.div`
  display: grid;
  justify-items: center;
  margin-bottom: 88px;
  @media(max-width: 960px){
    margin-bottom: 40px;
  }
`